import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-best-bba-placement-colleges-india',
  templateUrl: './best-bba-placement-colleges-india.component.html',
  styleUrls: ['./best-bba-placement-colleges-india.component.scss']
})
export class BestBbaPlacementCollegesIndiaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
